<script setup>
import { CategoryNav } from '@/components';
import { useDraftStore, usePublishedStore, useNewsPaperStore } from '@/stores';

import { useRouter } from 'vue-router';
import { ref } from 'vue'
import { storeToRefs } from 'pinia';
import Logo from '@/components/logo/components/Logo.vue';

let draftStore = ref();
const router = useRouter();
if(router.currentRoute.value.path.startsWith('/draft') || router.currentRoute.value.path == "/") {
  draftStore = useDraftStore();
} else {
  draftStore = usePublishedStore();
}


function newspaperSelect(newspaper_id) {
  const newsPaperStore = useNewsPaperStore();

  const publishedStore = usePublishedStore();
  const { publishedList } = storeToRefs(publishedStore);
  // From CategoryTree
  if(newspaper_id != newsPaperStore.selectedNewspaper || router.currentRoute.value.name != "draft-list-newspaper") {
    newsPaperStore.selectedNewspaper = newspaper_id;
    router.push({ path: '/draft/newspaper/' + newspaper_id });
  }
}

</script>

<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-light-primary elevation-2">
    <!-- Brand Logo -->
    <Logo />
    <!-- Sidebar -->
    <div class="sidebar">
      <CategoryNav v-if="draftStore" @newspaperselect="newspaperSelect" :newsStore="draftStore" :persist="true" />
    </div>
  </aside> 
  <div class="content-wrapper">
    <!-- List / -->
    <router-view  :key="$route.params[$route.meta.watchParam]"></router-view>
  </div>
  
  <footer class="main-footer">
    © <strong>More News</strong>
  </footer>
  

  
</template>

